import { draftResolutionOf } from '../../../contracts/approval-kinds';
import type { ToolUseItem } from '../../../contracts/harness.types';

import { SUPERSEDED_APPROVAL_REASON } from '../lib/steerPendingApprovals';

/**
 * A user-authored note left on a DENIED approval — the card's optional note
 * field, or a message typed while the approval was pending (carried as the
 * ``reason``). The backend writes no user turn for either, so the transcript
 * sources it off the run snapshot and the bubble survives a refetch.
 *
 * Excluded: the superseded marker, which would repeat one steer once per
 * parallel tool call, a draft card's resolution (which renders its own
 * receipt), and approvals — a free-text clarification's answer already renders
 * in the Answers card.
 */
export const deniedApprovalUserNote = (item: ToolUseItem): string | null => {
  const approval = item.approval;
  if (approval?.status !== 'denied') return null;
  const reason = approval.reason?.trim();
  if (
    !reason ||
    reason === SUPERSEDED_APPROVAL_REASON ||
    draftResolutionOf(approval) !== null
  ) {
    return null;
  }
  return reason;
};
